import React, { useContext } from 'react';
import SSPContentFieldAccessor from 'sspcontentext/src/model/accessor/SSPContentFieldAccessor';
import i18next from 'i18next';
import SSPContentVO from 'sspcontentext/src/model/SSPContentVO';
import {
	addOverlay,
	getNumberString,
	OverlayEnum,
	SspProviderContext,
} from '../../did-utility';

type UpperTableElementProps = {
	headline: string;
	className?: string;
	value1?: string | number;
	value2?: string | number;
	unit1?: string;
	unit2?: string;
	type?: 'number' | 'consumption' | 'wltp';
	engine?: SSPContentFieldAccessor;
	add?: any;
	disclaimer?: number | undefined;
	svg?: string | number;
};

const getValueByType = (
	type: string | undefined,
	value: string | number | undefined,
	engine: SSPContentFieldAccessor | undefined,
	language: string,
	second?: boolean
) => {
	const store = useContext(SspProviderContext);
	const contentModel = store.state.content
		? store.state.content.asModel
		: new SSPContentVO('').asModel;
	const vehicleDataModel = contentModel.ref('vehicle_data').asModel;

	if (!type || !value) return value;

	if (type === 'consumption') {

		if (engine?.str('engine_type') === 'HybridPetrol') {
			const fuel = getNumberString(
				vehicleDataModel.float(String(value), NaN),
				language
			);
			const electric = getNumberString(
				vehicleDataModel.float(String(value), NaN),
				language,
				undefined,
				1
			);

			return second ? electric : fuel;
		}

		if (engine?.str('engine_type') === 'Electric') {
			if (!second) return;
			return getNumberString(
				vehicleDataModel.float(String(value), NaN),
				language,
				undefined,
				1
			);
		}

		if (second) return;

		return getNumberString(
			vehicleDataModel.float(String(value), NaN),
			language,
			undefined,
			1
		);
	}

	if (type === 'wltp') {
		return getNumberString(
			vehicleDataModel.float(String(value), NaN),
			language
		);
	}

	return getNumberString(Number(value), language, undefined, 1);
};

export function UpperTableElement({
	headline,
	className,
	value1,
	value2,
	unit1,
	unit2,
	type,
	engine,
	add,
	disclaimer,
	svg,
}: UpperTableElementProps) {
	const store = useContext(SspProviderContext);
	const processedValue1 = getValueByType(
		type,
		value1,
		engine,
		i18next.language
	);
	const processedValue2 = getValueByType(
		type,
		value2,
		engine,
		i18next.language,
		true
	);

	const moreData = (
		<p className='small more-data'>
			{i18next.t('LinkAdditionalConsumptionData')}
			<svg className='icon-12'>
				<use xlinkHref='#chevron-xsmall' />
			</svg>
		</p>
	);

	return (
		<div
			className={`upper-table-element ${className}`}
			onClick={() => {
				add && addOverlay(store, OverlayEnum.Consumption);
			}}
		>
			<p className='short bold'>{i18next.t(headline)}</p>
			<span>
				{(processedValue1 || processedValue2) && (
					<>
						{processedValue1 && (
							<h1>
								{processedValue1}{' '}
								<span className='short bold'>
									{i18next.t(unit1 || '')}
									{disclaimer && disclaimer !== -1 && (
										<sup>{disclaimer}</sup>
									)}
								</span>
							</h1>
						)}
						{processedValue2 && processedValue2 !== '-' && (
							<h1>
								{processedValue2}{' '}
								<span className='short bold'>
									{i18next.t(unit2 || '')}
								</span>
							</h1>
						)}
						{add && moreData}
					</>
				)}
			</span>
			{svg && (
				<svg className='critair'>
					{svg === 1 ? (
						<use xlinkHref='#critAir1' />
					) : svg === 2 ? (
						<use xlinkHref='#critAir2' />
					) : svg === 'bev' ? (
						<use xlinkHref='#critAirBEV' />
					) : (
						<use />
					)}
				</svg>
			)}
		</div>
	);
}
